import type { LessonProgress } from '../types/lesson'

export interface ProgressStore {
  get(lessonSlug: string): Promise<LessonProgress | null>
  set(progress: LessonProgress): Promise<void>
  list(): Promise<LessonProgress[]>
}

const STORAGE_KEY = 'mandarin-daily.progress.v1'

export class LocalProgressStore implements ProgressStore {
  private readAll(): LessonProgress[] {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]') as LessonProgress[]
    } catch {
      return []
    }
  }

  async get(lessonSlug: string) {
    return this.readAll().find((item) => item.lessonSlug === lessonSlug) ?? null
  }

  async set(progress: LessonProgress) {
    const remaining = this.readAll().filter((item) => item.lessonSlug !== progress.lessonSlug)
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...remaining, progress]))
  }

  async list() {
    return this.readAll()
  }
}

// Replace this export with a Firebase/Supabase implementation later.
// The UI only depends on ProgressStore and needs no other changes.
export const progressStore: ProgressStore = new LocalProgressStore()
